// authStore.ts
import { create } from "zustand";
import { ACCESS_TOKEN_KEY } from "../hooks/useAccessToken";

type AuthSlice = {
  isAuthenticated: boolean;
  accessToken?: string;
  firstName?: string;
  lastName?: string;
  fullName?: string;
  workdayUsername?: string;
  isAdmin?: boolean;
  setFromEntraId: (args: {
    token?: string;
    accessToken?: string;
    claims?: Record<string, any>;
  }) => void;
  clear: () => void;
};

export const useAuthStore = create<AuthSlice>((set) => ({
  isAuthenticated: false,
  setFromEntraId: ({ token, accessToken, claims }) => {
    set({
      isAuthenticated: true,
      accessToken: accessToken || token,
      firstName: claims?.firstName ?? "",
      lastName: claims?.lastName ?? "",
      fullName: claims?.name ?? "",
      workdayUsername: claims?.workdayUsername ?? "",
      isAdmin: claims?.groups?.includes("Entra-Reece-WWPDFAdmin"),
    });
  },
  clear: () => {
    sessionStorage.removeItem(ACCESS_TOKEN_KEY);
    set({
      isAuthenticated: false,
      accessToken: undefined,
      firstName: undefined,
      lastName: undefined,
      fullName: undefined,
      workdayUsername: undefined,
      isAdmin: undefined,
    });
  },
}));
